// Touch: tap toggles card text; long-press opens the same .is-active state (ghost click suppressed).
if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
  document.addEventListener('DOMContentLoaded', function () {
    var sections = document.querySelectorAll('[data-section-type="ecomexperts-clients"]');
    var LONG_PRESS_MS = 320;
    var MOVE_THRESHOLD_PX = 12;

    sections.forEach(function (section) {
      var cards = section.querySelectorAll('.client-card');
      var activeCard = null;

      function openCard(card) {
        card.classList.add('is-active');
      }

      function closeCard(card) {
        card.classList.remove('is-active');
      }

      function handleOutsideClick(event) {
        if (activeCard && !section.contains(event.target)) {
          closeCard(activeCard);
          activeCard = null;
        }
      }

      cards.forEach(function (card) {
        var longPressTimer = null;
        var startX = 0;
        var startY = 0;
        var suppressClickOnce = false;

        function clearLongPressTimer() {
          if (longPressTimer) {
            clearTimeout(longPressTimer);
            longPressTimer = null;
          }
        }

        card.addEventListener(
          'touchstart',
          function (e) {
            if (e.touches.length !== 1) return;
            var t = e.touches[0];
            startX = t.clientX;
            startY = t.clientY;
            clearLongPressTimer();
            longPressTimer = window.setTimeout(function () {
              longPressTimer = null;
              if (activeCard && activeCard !== card) closeCard(activeCard);
              openCard(card);
              activeCard = card;
              suppressClickOnce = true;
            }, LONG_PRESS_MS);
          },
          { passive: true }
        );

        card.addEventListener(
          'touchmove',
          function (e) {
            if (!longPressTimer || !e.touches.length) return;
            var t = e.touches[0];
            if (
              Math.abs(t.clientX - startX) > MOVE_THRESHOLD_PX ||
              Math.abs(t.clientY - startY) > MOVE_THRESHOLD_PX
            ) {
              clearLongPressTimer();
            }
          },
          { passive: true }
        );

        card.addEventListener('touchend', clearLongPressTimer);
        card.addEventListener('touchcancel', clearLongPressTimer);

        card.addEventListener('click', function (event) {
          event.stopPropagation();
          if (suppressClickOnce) {
            suppressClickOnce = false;
            event.preventDefault();
            return;
          }
          if (activeCard === card) {
            closeCard(card);
            activeCard = null;
          } else {
            if (activeCard) closeCard(activeCard);
            openCard(card);
            activeCard = card;
          }
        });

        card.addEventListener('contextmenu', function (e) {
          e.preventDefault();
        });
      });

      document.addEventListener('click', handleOutsideClick);
    });
  });
}
